import type {
  RuntimePublicConfig,
  RuntimePublicConfigKey,
} from '@/src/lib/runtime-public-config.shared'

let runtimePublicConfig: RuntimePublicConfig = {}

export function setRuntimePublicConfig(config: RuntimePublicConfig): void {
  runtimePublicConfig = { ...config }
}

export function getRuntimePublicConfig(): RuntimePublicConfig {
  return runtimePublicConfig
}

export function getRuntimePublicConfigValue(
  key: RuntimePublicConfigKey
): string | undefined {
  return runtimePublicConfig[key] ?? process.env[key]
}
